// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"1e1aebc9","693":"e9a3ca19","983":"afd12a51"}[chunkId] + ".chunk.js";
};